import AwsService from "../service/awsService";
import AzureService from "../service/azureService";
import SSHService from "../service/sshService";
import SharePointService from "../service/sharePointService";
import AWSMultipartUploader from "./AWSMultipartUploader";
import store from "../store";

export default class fileUploader {
  // Default to 50MB
  chunkSize = 1024 * 1024 * 50;

  getLatestConfiguration() {
    const stateHolder = store.getState() ?? {};
    const uploadChunkSize = stateHolder?.config?.fileUploadChunkSizeInMB;
    return {
      files: stateHolder?.processQueue?.currentQueue ?? [],
      chunkSize: uploadChunkSize ? uploadChunkSize * 1024 * 1024 : this.chunkSize,
    };
  }

  async startUpload() {
    let state = this.getLatestConfiguration();

    let files = state.files;
    this.chunkSize = state.chunkSize;

    let uploadResponse = {};
    if (files.length) uploadResponse = await this.beginFirstUpload(files[0]);
    return uploadResponse;
  }

  async beginFirstUpload(uploadedFile) {
    let start = 0;
    let chunkCounter = 0;
    let numberofChunks = Math.ceil(uploadedFile.file.size / this.chunkSize);
    let chunkEnd = start + this.chunkSize;

    const uploadChunk = async (formData, chunkEnd) => {
      let blobEnd = chunkEnd - 1;

      let response = {};
      try {
        // Based on type upload the file to right connection
        if (uploadedFile.connectionType === "s3") {
          const aws = new AwsService();
          response = await aws.uploadObject(formData, uploadedFile.ProcessQueue_id, {
            "Content-Range": "bytes " + start + "-" + blobEnd + "/" + uploadedFile.file.size,
          });
        } else if (uploadedFile.connectionType === "azure") {
          const azure = new AzureService();
          response = await azure.upload(formData, uploadedFile.ProcessQueue_id, {
            "Content-Range": "bytes " + start + "-" + blobEnd + "/" + uploadedFile.file.size,
          });
        } else if (uploadedFile.connectionType === "sftp") {
          const ssh = new SSHService();
          response = await ssh.upload(formData, uploadedFile.ProcessQueue_id, {
            "Content-Range": "bytes " + start + "-" + blobEnd + "/" + uploadedFile.file.size,
          });
        } else if (uploadedFile.connectionType === "sharepoint") {
          const sharepoint = new SharePointService();
          response = await sharepoint.upload(formData, uploadedFile.ProcessQueue_id, {
            "Content-Range": "bytes " + start + "-" + blobEnd + "/" + uploadedFile.file.size,
          });
        }

        start += this.chunkSize;
        if (start < uploadedFile.file.size) {
          if (response.success) return await createChunk();
          else return { success: false, ProcessQueue_id: uploadedFile.ProcessQueue_id };
        } else return { success: true, ProcessQueue_id: uploadedFile.ProcessQueue_id };
      } catch (error) {
        return { success: false, ProcessQueue_id: uploadedFile.ProcessQueue_id };
      }
    };

    const createChunk = async () => {
      chunkCounter++;
      chunkEnd = Math.min(start + this.chunkSize, uploadedFile.file.size);

      //Slicing file
      const chunk = uploadedFile.file.slice(start, chunkEnd);
      const formData = new FormData();

      formData.append("files", chunk, uploadedFile.file.name);
      formData.append("ProcessQueue_id", uploadedFile.ProcessQueue_id);
      formData.append("lastChunk", numberofChunks === chunkCounter);
      formData.append("totalSize", uploadedFile.file.size);
      formData.append("chunkNo", chunkCounter);

      //Appending other params if file is last
      if (numberofChunks === chunkCounter) {
        formData.append("s3bucketName", uploadedFile.bucketName);
        formData.append("name", uploadedFile.prefix);
        formData.append("location", uploadedFile.prefix);
        formData.append("Stage_id", uploadedFile.stage);
      }

      //created the chunk, now upload iit
      return await uploadChunk(formData, chunkEnd);
    };

    if (uploadedFile.connectionType === "s3") {
      const response = await this.AWSMultiPartUpload(uploadedFile);
      if (response.success && response.needIndirectUpload) return await createChunk();
      return response;
    } else {
      // for other connections and s3 indirect upload
      //uploading the first chunk
      return await createChunk();
    }
  }

  async AWSMultiPartUpload(uploadedFile) {
    const files = [];
    files.push(uploadedFile);

    const config = store.getState()?.config ?? {};
    const S3ChunkSizeInBytes = (config?.s3FileUploadChunkSizeInMB ?? 10) * 1024 * 1024;
    const numberOfOpenThreads = config?.numberOfOpenThreads ?? 10;

    let data = {
      s3bucketName: uploadedFile.bucketName,
      name: uploadedFile.prefix,
      Stage_id: uploadedFile.stage,
      files: [],
    };

    //Adding all files to data
    for (const file of files) {
      const ProcessQueue_id = file.ProcessQueue_id;
      const _file = file.file;

      data.files.push({
        name: _file.name,
        parts: Math.ceil(_file.size / S3ChunkSizeInBytes),
        ProcessQueue_id,
      });
    }

    const aws = new AwsService();
    const { data: resData, success } = await aws.getUploadUrl(data);
    if (success) {
      //Checking if control panel can modify cores of bucket
      //If YES then uploading directly to s3 using presigned URL
      //ELSE uploading through control panel
      if (resData.hasUploadPermission) {
        const filewiseDataURLs = resData.uploadURLsByFile;

        let success = false;
        for (const { file, ProcessQueue_id } of files) {
          const { name } = file;

          const URLPartWise = filewiseDataURLs[name].URLs;
          const awsMultipartUploader = new AWSMultipartUploader(
            URLPartWise,
            file,
            S3ChunkSizeInBytes,
            numberOfOpenThreads
          );
          const Parts = await awsMultipartUploader.start();

          success = Parts?.ETags && Parts?.ETags.length > 0;
          if (Parts?.ETags && Parts?.ETags.length > 0)
            await awsMultipartUploader.complete({
              ProcessQueue_id,
              ...data,
              Parts: Parts.ETags,
              file: name,
              UploadId: filewiseDataURLs[name].fileId,
            });
          //If not aborted then only aborting
          else if (!Parts.has404Error) {
            await awsMultipartUploader.abort({
              ProcessQueue_id,
            });
          }
        }
        return { success, ProcessQueue_id: uploadedFile.ProcessQueue_id };
      }
      return { success: true, ProcessQueue_id: uploadedFile.ProcessQueue_id, needIndirectUpload: true };
    }
    return { success, ProcessQueue_id: uploadedFile.ProcessQueue_id };
  }
}
